import { render, staticRenderFns } from "./Prize.vue?vue&type=template&id=753d1660&scoped=true&"
import script from "./prize.js?vue&type=script&lang=js&"
export * from "./prize.js?vue&type=script&lang=js&"
import style0 from "./prize.scss?vue&type=style&index=0&id=753d1660&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753d1660",
  null
  
)

export default component.exports